import { track } from '@sloyd/analytics';
import * as api from '@sloyd/api';
import { actions, selectors } from '@sloyd/store-base';
import { toast } from '@sloyd/ui';
import { call, delay, fork, put, select, takeEvery } from 'saga-ts';
import { $ac, invokeEvent, l } from 'shared-base';
import { dataGuard } from './helpers/guards';

export const saga = {
  id: 'sloyd.packs',
  type: 'entity',
  root: root,
  trigger: {
    actionTypes: ['PACKS'],
  },
};

type Verb = 'load';

type Action = {
  type: 'PACKS';
  verb: Verb;
  id: string;
  payload: Json;
};

const map: Record<Verb, any> = {
  load: loadPack,
};

const analyitcsMapExamples: any = {
  load: 'Load Pack',
};

export function* loadPack(action: Action) {
  try {
    const { id } = action;

    const playground = yield* select(selectors.base.$playground);

    if (!playground) return;

    yield put(actions.currentIds.patch({ projectId: playground.id }));

    const res = yield* call(api.packs.get, id);

    if (!res.isSuccess) {
      toast.error('Error loading pack');
      return;
    }

    const { data } = res;
    const { models = [] } = data as Json;

    yield put(actions.models.setAll(models));

    yield put(
      actions.appState.patch({
        packId: id,
      })
    );

    yield delay(50);
    yield put($ac('PACK_LOADED'));
  } catch (err) {
    invokeEvent('sentry', { err });
  }
}

export function* packs(action: any) {
  const { verb, id } = action;
  yield delay(10);

  const saga = (map as any)[verb];

  if (!saga) {
    return;
  }

  l(`saga|saga.packs ${verb} on ${id}`);

  yield* dataGuard();
  track(analyitcsMapExamples[verb], { origin, id });

  yield* fork(saga, action);
}

export function* root() {
  yield takeEvery('PACKS', packs);
}
